import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from 'vue-router';
import { EXCEPTION_ROUTES } from '../views/exception/routes';
import Home from "../views/home/home.vue";
import News from "../views/news/news.vue";
import About from "../views/about/about.vue";

const routes: Array<RouteRecordRaw> = [
  ...EXCEPTION_ROUTES,
  {
    path: '/',
    name: 'Home',
    meta: { title: '首页' },
    component: Home
  }, {
    path: '/news',
    name: 'News',
    meta: { title: '公司动态' },
    component: News
  }, {
    path: '/about',
    name: 'About',
    meta: { title: '关于我们' },
    component: About
  }];

const router = createRouter({
  history: createWebHashHistory(),
  // history: createWebHistory(process.env.BASE_URL),
  routes
});

/** 路由切换前操作 */
router.beforeEach((to, _from, next) => {

  /** 设置页面标题 */
  if (to.meta.title) {
    if (to.meta.title == '首页') {
      document.title = `妈妈来了官网-100%自营月嫂-深圳月嫂公司-十大安全服务保障为您保驾护航`;
    } else {
      document.title = `妈妈来了 - ${String(to.meta.title)}`;
    }
  }

  /** 跳转路由 */
  next();
});

export default router;
